import { RadioTile, TileGroup } from 'carbon-components-react';
import React, { useEffect } from 'react';
import { QuesIDProps } from '../../Maas360Estimator';
import { segmentsTracking } from 'src/common/lib/tracker';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';
import { convertToString } from 'src/apps/maas360-estimator/lib/utils';

type Step4Props = {
  que4Value: string;
  setQue4Value: React.Dispatch<React.SetStateAction<string>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  setTrackQuesID: React.Dispatch<React.SetStateAction<QuesIDProps>>;
  trackQuesID: QuesIDProps;
  useTranslation: TranslationFunction;
};

const Step4 = ({
  que4Value,
  setQue4Value,
  setIsRequired,
  setTrackQuesID,
  trackQuesID,
  useTranslation,
}: Step4Props) => {
  useEffect(() => {
    if (que4Value) {
      setIsRequired(false);
    }
  }, []);

  const handleClick = (
    value: string,
    event: React.MouseEvent<HTMLInputElement>,
  ) => {
    setQue4Value(value);
    setIsRequired(false);
    setTrackQuesID({
      ...trackQuesID,
      Q4: (event.target as HTMLInputElement).id,
    });
    segmentsTracking('CTA Clicked', {
      pageTitle: 'MaaS360 Plan Assessment',
      object: 'Mass360 page',
      resultValue: 'CTA clicked',
      CTA: `question 4 - ${value} - selected`,
      location: 'Assessment',
      action: '',
      field: '',
    });
  };

  const yes = convertToString(useTranslation('yes', true));
  const no = convertToString(useTranslation('no', true));

  return (
    <div>
      <div className="page_sub_heading padding_8">
        {useTranslation('que4_text_desc')}
      </div>
      <TileGroup
        name="radio-group"
        className="tilegroup"
        valueSelected={que4Value}
      >
        <RadioTile
          className="tile"
          id="Q4A1"
          value="Yes"
          onClick={(e) => handleClick(yes, e)}
        >
          {useTranslation('yes')}
        </RadioTile>
        <RadioTile
          className="tile"
          id="Q4A2"
          value="No"
          onClick={(e) => handleClick(no, e)}
        >
          {useTranslation('no')}
        </RadioTile>
      </TileGroup>
    </div>
  );
};

export default Step4;
